const baseURL = process.env.baseURL;
localStorage.baseURL=baseURL
export const apiUtil = {

}



// WEBPACK FOOTER //
// ./src/request/api.js